<template>
	<div class="jiaoshi">
		<ul class="flexDiv">
			<li v-for="(item,index) in dataList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
        <p class="imgBox"><img :src="item.Cover" alt=""></p>
        <h1>{{item.Title}}</h1>
        <div class="detail">
          <a :href="item.Url">
            <p class="ellipsisBox">{{item.Describe}}</p>
            <span>点击查看详情</span>
          </a>
        </div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'jiaoshi',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jiaoshi.vue